import React, { useCallback, useContext, useEffect, useState } from 'react'
import PageTitle from '../../Components/PageTitle'
import { NoRecords } from '../../Components/Shimmer'
import axios from 'axios'
import Swal from 'sweetalert2'
import { ConfigContext } from '../../Context/ConfigContext'
import { formatDate, IconButton, SubmitButton, TextBox } from '../../Components/InputElements'
import SentEmails from './SentEmails'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import TooltipComponent from '../../Components/TooltipComponent'
import { currentDateAndTime, decodeData } from '../../Constants/constants'
import { useLocation } from 'react-router-dom';
import MainPageLoader from '../../Components/MainPageLoader';

const EmailBox = () => {
  const { apiURL, apiHeaderJSON, permissions } = useContext(ConfigContext);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const encodedData = queryParams.get("abs");
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
    
  const [rows, setRows] = useState([]);
  const [viewEmailTemplate, setViewEmailTemplate] = useState(false);
  const [viewDocument, setViewDocument] = useState(false);
  const [emailtemplate, setEmailtemplate] = useState({ emailId:"", emailBody:"", emailSubject: "" });
  const [filter, setFilter]=useState({ keyword:"", from_date: "", to_date:"" })
  const [pagination, setPagination] = useState({
    next: false,
    prev: false,
    page: 1,
    total_records: '',
    total_pages: '',
    limit: 10
  });
  const [sentEmailModal, setSentEmailModal] = useState(false)
  const [loadingList, setLoadingList] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingFilter, setLoadingFilter] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [limitAction, setLimitAction] = useState(false);
  const limitOptions = [10, 25, 50, 100, 200, 500]

  const getList = () => {
    const headers = apiHeaderJSON
    axios
      .get(`${apiURL}MailMaster/GetComposeEmailsList`, {
        params: {
          limit: pagination?.limit,
          page: pagination?.page,
          keyword: filter?.keyword ,
          from_date: filter?.from_date,
          to_date: filter?.to_date,
        },
        headers
      })
      .then(response => {
        const data = response.data
        console.log(response?.data)
        if (response.data.success === true) {
          setRows(data?.data);
          console.log("data?.total_records,",data?.total_records,)
          setPagination({
            ...pagination,
            next: data?.next,
            prev: data?.prev,
            page: data?.page,
            total_records: data?.total_records,
            total_pages: data?.total_pages
          })
         
        } else {
        }
        setLoadingList(false);
        setLoadingSearch(false);
        setLoadingFilter(false);
      })
      .catch(function (error) {
        console.error('error', error);
        setLoadingList(false);
        setLoadingSearch(false);
        setLoadingFilter(false);
      })
  }

  const getInfo=(row)=>{
    let newState = {
      fileName: row?.attachments_url,
      fileSize: "",
    };

    if (row?.attachments_url && row?.attachments_url.includes("pdf")) {
        newState = {
            ...newState,
            isValidPdfFile: true,
            fileTypeIcon: "/img/pdf-logo.svg",
        };
    }
    else if(row?.attachments_url && row?.attachments_url.includes(".xlsx")){
      newState = {
          ...newState,
          // selectedImage: URL.createObjectURL(file),
          fileTypeIcon: "/assets/excel-icon.png",
      };
  }
   else {
        newState = {
            ...newState,
            // selectedImage: URL.createObjectURL(file),
            fileTypeIcon: "/img/img-logo.png",
        };
    }
    setEmailtemplate({
        ...emailtemplate,
        emailFile: row?.attachments_url,
        emailId: row?.mail_sent_id,
        emailBody: row?.email_body,
        emailSubject:  row?.email_subject,
        email_attachments: row?.attachments_url,

        fileData: newState,
    });
    setViewEmailTemplate(true);
  }


  useEffect(() => {
    setLoadingList(true);
    getList()
  }, []);

  
  const handleInputChange = (e) => {
    console.log("e.target.name, e.target.value",e.target.name,"=",e.target.value);
    setFilter({
        ...filter,
        [e.target.name]: e.target.value,
      });
      if (!e.target.value) {
        setIsChanged(true);
        setLoadingSearch(true);
      }
  };
  const handleInputSearch = (e) => {
      getList();
  };

  const handleDelete = company_salary_head_id => {
    const headers = apiHeaderJSON
    Swal.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this item!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true
    }).then(result => {
      if (result.isConfirmed) {
        let data = {
          company_salary_head_id: company_salary_head_id
        }
        // console.log("delete handle called");
        axios
          .post(`${apiURL}Payrolls/DeleteSalaryHead`, data, {
            headers
          })
          .then(response => {
            const { success } = response.data
            console.log('handleDelete ~ response =======>>>', response)
            if (success === true) {
              Swal.fire({
                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                text: response.data.message,
                icon: success ? 'success' : 'error',
                showConfirmButton: true,
                allowOutsideClick: false // Show OK button
              }).then(result => {
                if (result.isConfirmed) {
                  getList()
                }
              })
            } else {
              Swal.fire({
                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                text: response.data.message,
                icon: success ? 'success' : 'error',
                showConfirmButton: true,
                allowOutsideClick: false // Show OK button
              }).then(result => {
                if (result.isConfirmed) {
                }
              })
            }
          })
      }
    })
  }
  const handleToggleSwitch = (mail_id, toggleButton) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to change head status to ${
        toggleButton ? 'On' : 'Off'
      }`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No!',
      reverseButtons: true
    }).then(result => {
      if (result.isConfirmed) {
        const data = {
          mail_template_id: mail_id,
          template_status: toggleButton ? '1' : '0',
          date: currentDateAndTime()
        }
        console.log("data====>",data)
        const headers = apiHeaderJSON
        console.log(data)
        axios
          .post(`${apiURL}MailMaster/HandleTemplateAccess`, data, {
            headers
          })
          .then(response => {
            const { success } = response.data
            // console.log('handleToggleSwitch ~ response =======>>>', response)
            if (success === true) {
               getList();
            } else {
                Swal.fire({
                    title: `<strong>"Failed"</strong>`,
                    text: response?.data?.message,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false
                  });
            }
          })
      }
      // else {
      //     Swal.fire({
      //         title: 'Cancelled',
      //         text: 'Cancelled..',
      //         icon: 'info',
      //         timer: 1500,
      //         showConfirmButton: false
      //     });
      //     return; // Do nothing if the user cancels
      // }
    })
  }

    useEffect(()=>{
      if(limitAction){
        getList();
        setLimitAction(false)
      }
    },[limitAction]);

  const handleLimitChange = e => {
    console.log(e.target.value)
    setPagination({
      ...pagination,
      limit: e.target.value,
      page: 1
    })
    setLimitAction(true)
  }

  const handlePageChange = e => {
    console.log(e.target.value)
    setPagination({
      ...pagination,
      page: parseInt(e.target.value)
    })
    setLimitAction(true)
  }
  const handlePrev = () => {
    console.log(pagination?.prev)
    if (pagination?.prev === true) {
      console.log(pagination?.page - 1)
      setPagination({
        ...pagination,
        page: pagination?.page - 1
      })
    }
    setLimitAction(true)
  }
  const handleNext = () => {
    console.log(pagination?.next)
    if (pagination?.next === true) {
      console.log(pagination?.page + 1)
      setPagination({
        ...pagination,
        page: pagination?.page + 1
      })
    }
    // getList();
    setLimitAction(true)
  }

  const handleClearAll=()=>{
    setFilter({
      ...filter,
      from_date: "",
      to_date:"",
    });
    setIsChanged(true)
  }
  useEffect(()=>{
    if(isChanged){
      getList();
      setIsChanged(false);
    }
  },[isChanged]);

  const downloadFile = (url) => {
    const fileName = url.split("/").pop(); // Extract the file name from the URL
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.target = '_blank'
    anchor.download = fileName; // Set the download attribute with the file name
    document.body.appendChild(anchor); // Append the anchor to the document
    anchor.click(); // Trigger the download
    document.body.removeChild(anchor); // Remove the anchor after download
  };
  // used for filter result
  const handleFilter = useCallback(()=>{
    if (!loadingFilter) setLoadingFilter("1"); handleInputSearch();
  }, [handleInputSearch, loadingFilter]);
  // used for clear filter
  const handleClear = useCallback(()=>{
    if (!loadingFilter) setLoadingFilter("2"); handleClearAll();
  }, [handleClearAll, loadingFilter]);
  // used open email modal
  const handleEmailModal = useCallback(()=>{
    setSentEmailModal(!sentEmailModal);
  }, [sentEmailModal]);
  // used close email view modal
  const handleCloseEmailViewModal = useCallback(()=>{
    setViewEmailTemplate(false); 
    setEmailtemplate({...emailtemplate, emailId: "", emailBody: "", emailSubject: "",});
  }, [emailtemplate]);

  if (loadingList) return <MainPageLoader/>

  return (
    <div className='main-content'>
      <div className='page-content'>
        <div className='container-fluid'><br />
          <PageTitle title={`${sentEmailModal? "Sent Email" : "Email Box"}`} primary={`Home`} />
          {!sentEmailModal ? 
          (<div className='row'>
            <div className='col-md-12'>
              <div className='card'>
                <div className="card-header ">
                  <div className="row col-md-12">
                    <div className="col-md-3">
                      <label htmlFor="keyword">Search Email</label>
                      <div className="input-group">
                        <input type="search" className="form-control" onChange={handleInputChange} name="keyword"
                          value={filter.keyword} aria-label="Recipient's username" aria-describedby="button-addon2"
                          placeholder="Search here..."
                        />
                        <button className="btn btn-success" onClick={() => { if ( filter.keyword && !loadingSearch) { setLoadingSearch(true); handleInputSearch();}}}
                          type="button" id="button-addon2" >
                          {loadingSearch ? (
                            <span class="spinner-border flex-shrink-0" role="status" style={{ width: "0.8rem", height: "0.8rem", borderWidth: "2px", }}>
                              <span class="visually-hidden">Loading...</span>
                            </span>
                          ) : (
                            <i className="ri-search-line"></i>
                          )}
                        </button>
                      </div>
                    </div>
                    <div className="col-md-3">
                        <TextBox type="Date" id="from_date" name="from_date" label="Email Sent From Date" value={filter.from_date} change={handleInputChange}/>
                    </div>
                    <div className="col-md-3">
                      <TextBox type="Date" id="to_date" name="to_date" label="Email Sent To Date" value={filter.to_date} change={handleInputChange}/>
                    </div>
                    <div className="col-md-3">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Apply Filter</label>
                          <SubmitButton onClick={handleFilter} 
                          disabled={!filter?.from_date && !filter?.to_date} 
                          loading={loadingFilter==="1"} loadingMessage='loading'
                          buttonName={'Filter'} icon={'ri-filter-3-fill'} type='info' iconSide='left'/>
                        </div>
                        <div className="col-md-6">
                          <label>Clear Filter</label>
                          <SubmitButton onClick={handleClear} 
                          disabled={!filter?.from_date && !filter?.to_date} 
                          loading={loadingFilter==="2"} loadingMessage='loading'
                          buttonName={'Clear'} icon={'ri-database-2-line'} type='secondary' iconSide='left'   />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='card-header align-items-center d-flex'>
                  { decodedData?.includes(2) && ( 
                    <SubmitButton onClick={handleEmailModal} 
                    buttonName={'Compose'} icon={'ri-add-circle-line'} type='secondary' iconSide='left' float='right' />)
                  }
                </div>
                <div className='card-body'>
                  <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                    <table style={{ minwidth: '100%' }} className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped text-center">
                        <thead className='bg-primary text-light bg-gradient position-sticky top-0 z-1'>
                          <tr>
                            <th width={`5%`} className=' text-center noWrap'>Sr.No.</th>
                            <th width={`10%`} className=' text-center'>Sent Date</th>
                            <th width={`10%`} className=' text-center noWrap'>Employee Code</th>
                            <th >Sent To</th>
                            <th >Email Subject</th>
                            <th width={`15%`} className=' text-center'>Status</th>
                            { decodedData?.includes(1) && ( <th width={`10%`} className=' text-center'>Action</th>)}
                          </tr>
                      </thead>
                      {!loadingList ? (
                        rows?.length === 0 ? (
                          <tbody>
                            <tr>
                              <td colSpan={12}>
                                <NoRecords />
                              </td>
                            </tr>
                          </tbody>
                        ) : (
                          <tbody>
                            {rows?.map((row, idx) => {
                              return (
                                <tr key={row?.mail_sent_id}>
                                  <td className=' text-center noWrap'>{idx + 1}</td>
                                  <td className=' text-center noWrap'>{row?.email_sent_datetime? formatDate(row?.email_sent_datetime):"--"}</td>
                                  <td className=' text-center noWrap'>{row?.employee_code || "--"}</td>
                                  <td>{row?.employee_name || "--"}</td>
                                  <td>{row?.email_subject || '--'}</td>
                                  <td className=' text-center'><div style={{ fontSize: "0.65rem" }} className={` bg-${row?.EmailStatusClasses} fw-semibold px-1 text-center py-1 text-white rounded-4`}>{row?.email_status_text}</div></td>
                                  { decodedData?.includes(1) && (
                                  <td className='d-flex justify-content-around'>
                                    {/* <button onClick={() => handleDelete(row?.mail_template_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button> */}
                                    { decodedData?.includes(1) && ( 
                                    <IconButton onClick={() => getInfo(row)} type='success' icon='ri-file-info-line' tooltipName='View' tooltipPosition='bottom' />)}
                                  </td>)}
                                </tr>
                              )
                            })}
                          </tbody>
                        )
                      ) : (
                        <tbody>
                          <tr>
                            <td colSpan={12}>
                              <div className='text-center mt-3'>
                                <span className='text-info'>
                                  <i className='mdi mdi-loading mdi-spin fs-1 align-middle me-2' />{' '}
                                  Loading.....
                                </span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      )}
                    </table>
                  </div>
                  <div className="d-flex bg-light justify-content-between flex-wrap align-items-center w-100 py-2 px-2 flex-wrap">
                    {/* <button disabled={!pagination?.prev} type='button' onClick={() => handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}>
                      <i className='ri-arrow-left-line label-icon align-middle fs-16 me-2' />
                      Previous
                    </button> */}
                    <SubmitButton onClick={()=>{ handlePrev() }} 
                    disabled={!pagination?.prev}
                    buttonName={"Previous"}  type='warning' icon='ri-arrow-left-line' />
                    <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                      {
                        <small>
                          Total Records: {pagination?.total_records} |
                          Total Pages: {pagination?.total_pages} |
                          Current Page: {pagination?.page}
                        </small>
                      }
                    </div>
                    <div className='col-md-2'>
                      <select className='form-select' onChange={e => { handlePageChange(e) }}>
                        {Array.from(
                          { length: pagination?.total_pages },
                          (_, i) => (
                            <option selected={pagination?.page === i + 1} key={i} value={i + 1}>
                              Page {i + 1}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                    <div className='col-md-2'>
                      <select className='form-select' onChange={handleLimitChange} value={pagination?.limit}>
                        {limitOptions.map(option => (
                          <option key={option} value={option}>
                            Limit {option}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* <button disabled={!pagination?.next} type='button' onClick={() => handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}>
                      <i className='ri-arrow-right-line label-icon align-middle fs-16 ms-2' />
                      Next
                    </button> */}
                    <SubmitButton onClick={()=>{ handleNext() }}
                    disabled={!pagination?.next}
                    iconSide='right' buttonName={"Next"}  type='primary' icon='ri-arrow-right-line' />
                  </div>
                </div>
              </div>
            </div>
          </div>):
          (
            <SentEmails onClick={handleEmailModal} />
        )}
          
            {viewEmailTemplate && (
              <div className="modal show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)",}}>
                  <div className=" bg-light mt-4 m-auto" style={{ width: "75%" }} >
                      <div className="modal-content">
                      <div className="">
                          <div style={{ borderBottom: "1px solid var(--vz-border-color)",}} className=" py-3 px-3 d-flex justify-content-between align-items-center">
                            <h4 className="card-title mb-0">
                                Email
                            </h4>
                            <button onClick={() => { setViewEmailTemplate(false); setEmailtemplate({...emailtemplate,emailId: "",emailBody: "",emailSubject: "",});}} className="btn-close" aria-label="Close"/>
                          </div>
                      </div>
                      <div style={{ padding: "0 10px 10px 10px" }} className="modal-body">
                          <div className='card-body'>
                            <div className='row'>
                              <div className="col-md-6 mt-3 mb-3">
                                  <label htmlFor="emailSubject" className="form-label">Email Subject</label>
                                  <input type='text' id='emailSubject' name='emailSubject' value={emailtemplate?.emailSubject} className={`form-control`} placeholder='Subject' disabled/>
                              </div>
                              <div className='col-md-6 mb-3 mt-3'>             
                                <label className="form-label">Attachment { !emailtemplate.emailFile ? <small className='text-muted '>(Not Attached)</small>:null}</label>
                                <div>
                                  {emailtemplate.emailFile && 
                                  ( <ul className="list-unstyled mb-0" id="dropzone-preview">
                                        <li className="dz-processing dz-error dz-complete" id="dropzone-preview-list">
                                            <div className="border rounded px-2 py-1">
                                                <div className="d-flex align-items-center gap-2">
                                                    {/* <div className={`flex-shrink-0 me-3`}> */}
                                                     <TooltipComponent name='Download File' position='bottom' >
                                                        <div onClick={()=>{
                                                          if(emailtemplate?.emailFile){
                                                            downloadFile(emailtemplate?.emailFile)
                                                          }
                                                          else{
                                                            Swal.fire({
                                                              title: `<strong>Failed</strong>`,
                                                              text: 'File Not Found!',
                                                              icon: 'error',
                                                              showConfirmButton: true,
                                                              allowOutsideClick: false 
                                                            })
                                                          }
                                                           }} className=" cursorPointer bg-light rounded p-1 d-flex align-items-center justify-content-center">
                                                            {/* <i className={emailtemplate.fileData?.fileTypeIcon} style={{ position: "absolute", color: "green", marginLeft: "12px", marginTop: "5px", fontSize: "25px" }}></i> */}
                                                            <img style={{ width:"25px"}} src={emailtemplate.fileData?.fileTypeIcon} alt="pdf" />
                                                        </div>
                                                      </TooltipComponent>
                                                    {/* </div> */}
                                                    <div className="flex-grow-1">
                                                        <div className="pt-1">
                                                            <h5 className="fs-13 mb-1 text-ellipse">
                                                                {emailtemplate?.emailFile?.split('/')[emailtemplate?.emailFile?.split('/').length - 1]}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>)
                                  }
                                    
                                </div> 
                              </div>
                            </div>
                            
                            <CKEditor
                                editor={ClassicEditor}
                                data={emailtemplate?.emailBody}
                                name={'mailBody'}
                                // onChange={handleEditorChange}
                                disabled
                            />
                            <div className=" d-flex align-items-center gap-2 mt-3">
                                <SubmitButton onClick={handleCloseEmailViewModal} 
                                buttonName={'Close'} icon={'ri-close-line'}  type='danger' iconSide='left' float='' />
                            </div>
                          </div>
                          
                      </div>
                      </div>
                  </div>
              </div>)   
            }
            {viewDocument && (
              <div className="modal show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }} aria-labelledby="myModalLabel" aria-hidden="true">
                <div className=" bg-light m-auto mt-3" style={{ width: "50%" }}>
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="myModalLabel">Attachment</h5>
                      <button onClick={() => { setViewDocument(false); }} className="btn-close"aria-label="Close"/>
                    </div>
                    <div style={{ padding: "0 10px 10px 0" }} className="modal-body">
                      <div className="row">
                        <div className="mb-4 m-auto p-1 rounded-2 grayBlurShadow" style={{ width: "80%" }}>
                          <h5 className="text-center">{emailtemplate?.fileData?.fileName || "--"}</h5>
                          <div className="m-auto rounded-3 overflow-hidden" style={{ width: "100%", height: "600px", border: "1px solid #ccc", }}>
                              {emailtemplate?.emailFile && emailtemplate?.emailFile?.includes("pdf") ? (
                              <iframe
                                  src={emailtemplate?.emailFile}
                                  title="PDF Viewer"
                                  style={{
                                  width: "100%",
                                  height: "100%",
                                  }}
                                  frameBorder="0"
                              >
                                  This browser does not support embedded
                                  files.
                              </iframe>
                              ) : (
                              emailtemplate?.emailFile?
                              <img src={emailtemplate?.emailFile} style={{ width: "100%", }} alt="document_image"/> :
                              <p>Attachment Not Found!</p>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  )
}

export default EmailBox;
